module.exports = __webpack_public_path__ + "static/media/AnswerDelta.3a6859be.svg";